export default __webpack_public_path__ + "static/media/left_icon.62c1946b.svg";